import React from 'react';
import {
  Popover,
  Box,
  Typography,
  Divider,
  MenuList,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Button,
} from '@mui/material';

export default function ColumnFilter({
  anchorEl,
  onClose,
  columnLabel,
  uniqueValues = [],
  selectedValues = [],
  onToggleValue,
  onClear,
}) {
  const open = Boolean(anchorEl);
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <Box sx={{ p: 2, minWidth: 240, maxHeight: 420 }}>
        <Typography variant="subtitle2" gutterBottom>
          Filter by {columnLabel}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <MenuList dense sx={{ maxHeight: 320, overflowY: 'auto' }}>
          {uniqueValues.map(({ value, label }) => (
            <MenuItem
              key={value}
              onClick={() => onToggleValue(value)}
              sx={{ py: 0.5 }}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={selectedValues.includes(value)}
                  //   checked={true}
                  tabIndex={-1}
                  disableRipple
                  size="small"
                />
              </ListItemIcon>
              <ListItemText
                primary={label || '(empty)'}
                primaryTypographyProps={{ noWrap: true }}
              />
            </MenuItem>
          ))}
        </MenuList>

        <Box sx={{ mt: 2, display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button size="small" onClick={onClear}
            disabled={selectedValues.length === 0}>
            Clear
          </Button>
        </Box>
      </Box>
    </Popover>
  );
}